import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { CreditCard } from "lucide-react";
import { api, fmtDate, ghs } from "../../lib/api";
import { EmptyState, PageHeader, StatusBadge } from "../../components/site/Bits";
import { FullLoader } from "../../components/site/Guards";

export default function Payments() {
  const [items, setItems] = useState(null);
  const nav = useNavigate();
  useEffect(() => { api.get("/payments/mine").then((r) => setItems(r.data)).catch(() => setItems([])); }, []);

  return (
    <div className="space-y-10">
      <PageHeader eyebrow="Billing" title="Payment history" text="Every payment attempt with its reference and verified status." />
      {items === null ? <FullLoader /> : items.length === 0 ? (
        <EmptyState icon={CreditCard} testId="payments-empty" title="No payments yet" text="When you check out, your transactions will be listed here." />
      ) : (
        <div className="card-rx overflow-x-auto">
          <table className="w-full min-w-[640px] text-sm" data-testid="payments-table">
            <thead><tr className="border-b border-white/[0.06] text-left text-xs uppercase tracking-wider text-slate-500">
              <th className="px-5 py-4">Reference</th><th className="px-5 py-4">Item</th><th className="px-5 py-4">Amount</th><th className="px-5 py-4">Date</th><th className="px-5 py-4">Status</th><th className="px-5 py-4" />
            </tr></thead>
            <tbody className="divide-y divide-white/[0.04]">
              {items.map((t) => (
                <tr key={t.reference} data-testid={`payment-row-${t.reference}`}>
                  <td className="px-5 py-4 font-mono-rx text-slate-300">{t.reference}</td>
                  <td className="px-5 py-4 text-white">{t.item_name}</td>
                  <td className="px-5 py-4 font-mono-rx text-slate-200">{ghs(t.amount_minor)}</td>
                  <td className="px-5 py-4 text-slate-400">{fmtDate(t.created_at, true)}</td>
                  <td className="px-5 py-4"><StatusBadge status={t.status} /></td>
                  <td className="px-5 py-4 text-right">
                    {t.status === "pending" && <button onClick={() => nav(`/payment/callback?transaction_id=${t.reference}`)} className="text-xs font-semibold text-emerald-300 hover:text-emerald-200" data-testid={`payment-check-${t.reference}`}>Check status</button>}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}
